import Header from "../../Header/Header";
import Select from "react-select";

import { privateRequest } from "../../commonApi/CommonApi";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

const daysOptions = [
  { value: "Monday", label: "Monday" },
  { value: "Tuesday", label: "Tuesday" },
  { value: "Wednesday", label: "Wednesday" },
  { value: "Thursday", label: "Thursday" },
  { value: "Friday", label: "Friday" },
  { value: "Saturday", label: "Saturday" },
  { value: "Sunday", label: "Sunday" },
];
function Addcoupons() {
  const [selectAll, setSelectAll] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedFreeService, setSelectedFreeService] = useState();
  const [selectedExOptions, setSelectedExOptions] = useState([]);
  const [couponCode, setCouponCode] = useState("");
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [couponTitle, setCouponTitle] = useState(null);
  const [couponSubTitle, setCouponSubTitle] = useState(null);
  const [couponType, setCouponType] = useState(null);
  const [couponValue, setCouponValue] = useState(null);
  const [minSpend, setMinSpend] = useState(null);
  const [expiryDate, setExpiryDate] = useState(null);
  const [couponUsesLimit, setCouponUsesLimit] = useState(null);
  const [userUsesLimit, setUserUsesLimit] = useState(null);
  const [couponCapping, setCouponCapping] = useState(null);
  const [Status, setStatus] = useState(null);
  const [combineData, setCombineData] = useState([]);
  const [selectedChildCategories, setSelectedChildCategories] = useState([]);
  const [selectedParentCategory, setSelectedParentCategory] = useState();
  const [childCategoryOptions, setChildCategoryOptions] = useState([]);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [exServiceOptions, setExServiceOptions] = useState([]);
  const [SelectedChildCategory, setSelectedChildCategory] = useState("");
  const [Users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [couponDescription, setcouponDescription] = useState([]);
  const [selectedDays, setSelectedDays] = useState([]);
  const [selectedexUsers, setSelectedexUsers] = useState([]);
  const [selectAllInItem, setselectAllInItem] = useState(false);
  const [selectAllExItem, setselectAllExItem] = useState(false);
  const [selectAllDays, setselectAllDays] = useState(false);
  const [ServiceGroupOptions, setServiceGroupOptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [debouncedInput, setDebouncedInput] = useState("");

  const handleShow = () => {
    setName("");
    setEmail("");
    setMobile("");
    setShowModal(true);
  };
  const handleClose = () => setShowModal(false);
  const navigate = useNavigate();

  const handleInputChange = (index, event) => {
    const values = [...couponDescription];
    values[index] = event.target.value;
    setcouponDescription(values);
  };

  const handleAddInput = () => {
    setcouponDescription([...couponDescription, ""]);
  };

  const handleDeleteInput = (index) => {
    const values = [...couponDescription];
    values.splice(index, 1);
    setcouponDescription(values);
  };

  const getAllDocumentData = async () => {
    try {
      const response = await privateRequest.get("Service/CombineApis");
      setCombineData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };

  const getUsers = async () => {
    try {
      const response = await privateRequest.get("Appregister/getAllUser");
      setUsers(response?.data?.data);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };

  const handleServiceChange = (selectedOptions) => {
    setSelectedOptions(selectedOptions);
  };
  const handleFreeServiceChange = (selectedOptions) => {
    setSelectedFreeService(selectedOptions);
  };

  const handleServiceEXChange = (selectedOptions) => {
    setSelectedExOptions(selectedOptions);
  };

  const handleSelectAll = (e) => {
    setSelectAll(e.target.checked);
    setSelectedOptions(e.target.checked ? serviceOptions : []);
  };

  const handleUserChange = (selectedOptions) => {
    setSelectedUsers(selectedOptions);
  };

  const handleexUserChange = (selectedOptions) => {
    setSelectedexUsers(selectedOptions);
  };

  const handleDaysChange = (selectedOptions) => {
    setSelectedDays(selectedOptions);
  };

  const AddCoupons = async (event) => {
    event.preventDefault();
    // selectedFreeService ho selectedFreeService nahi to error show
    if (!selectedFreeService && couponType === "FreeService") {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please select a free service",
      });
      return;
    }
    try {
      const selectedOptionIdsString = selectedOptions.map(
        (option) => option.value
      );
      const selectedOptionIds = selectedExOptions.map((option) => option.value);
      const selectedUserIds = selectedUsers.map((user) => user.value);
      const selectedexUserIds = selectedexUsers.map((user) => user.value);
      const selectedDaysValues = selectedDays.map((day) => day.value);
      const formData = {
        couponCode,
        PCgroup: selectedParentCategory,
        PCatId: selectedChildCategories,
        inItem: selectedOptionIdsString,
        exItem: selectedOptionIds,
        inUserIDs: selectedUserIds,
        exUserIDs: selectedexUserIds,
        couponTitle,
        couponSubTitle,
        couponType,
        minSpend,
        couponDescription,
        expiryDate: expiryDate,
        couponUsesLimit,
        userUsesLimit,
        couponCapping,
        couponDays: selectedDaysValues,
        Status,
        ...(selectedFreeService && { serviceId: selectedFreeService }),
        ...(couponType !== "FreeService" && { couponValue: couponValue }),
      };

      const response = await privateRequest.post(
        "/coupons/createCoupon",
        formData
      );
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Coupons added successfully!",
      });
      navigate("/coupons");
      console.log("POST Response:", response);

      setCouponCode("");
      setSelectedGroup(null);
      setCouponTitle("");
      setCouponSubTitle("");
      setCouponType("");
      setCouponValue("");
      setMinSpend("");
      setExpiryDate("");
      setCouponUsesLimit("");
      setUserUsesLimit("");
      setCouponCapping("");
      setStatus("");
    } catch (error) {
      console.error("Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response.data.message,
      });
    }
  };

  function generateCoupon() {
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var code = "";
    for (var i = 0; i < 12; i++) {
      code += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    setCouponCode(code);
  }

  const handleParentCategoryChange = (selectedOption) => {
    // alert(selectedOption?.value)
    setSelectedParentCategory(selectedOption?.value);
    setSelectedChildCategory("");
  };

  const freeServiceOptions =
  combineData?.newServiceId
    ?.filter((service) => service?.PCatId?.PCGroup === selectedParentCategory)
    ?.flatMap((service) =>
      service?.ServiceVarients?.map((variant) => ({
        value: variant?._id,
        label: `${service?.ServiceName} (${variant?.ServiceType?.Name})`,
      }))
    ) || [];

  const filteredOptions = debouncedInput
  ? freeServiceOptions.filter((option) =>
      option.label
        ?.toLowerCase()
        .includes(debouncedInput.toLowerCase())
    )
  : freeServiceOptions;

  useEffect(() => {
    getAllDocumentData();
    getUsers();
  }, []);

  useEffect(() => {
  const timer = setTimeout(() => {
    setDebouncedInput(searchInput);
  }, 400); // debounce time

  return () => clearTimeout(timer);
}, [searchInput]);

  useEffect(() => {
    const childCategorySelectOptions = combineData?.parentCategories
      ?.filter((category) => category.PCGroup === selectedParentCategory)
      ?.map((category) => ({
        value: category._id,
        label: category.PCName,
      }));
    setChildCategoryOptions(childCategorySelectOptions || []);
  }, [selectedParentCategory, combineData?.parentCategories]);

  useEffect(() => {
    const serviceGroupSelectOptions = combineData?.serviceGroups
      ?.filter((group) => group.PCName[0] === selectedParentCategory)
      ?.map((group) => ({
        value: group._id,
        label: group.GroupName,
      }));
    setServiceGroupOptions(serviceGroupSelectOptions || []);
  }, [selectedParentCategory, combineData?.serviceGroups]);

  useEffect(() => {
    if (
      selectedChildCategories?.length > 0 &&
      combineData?.newServiceId &&
      combineData?.Package
    ) {
      const selectedServices =
        combineData?.newServiceId
          ?.filter((service) => {
            const { PCatId } = service;

            if (Array.isArray(PCatId)) {
              return selectedChildCategories?.some((category) =>
                PCatId.includes(category)
              );
            } else {
              return selectedChildCategories?.some(
                (item) => PCatId._id === item
              );
            }
          })
          ?.flatMap((service) =>
            service.ServiceVarients.map((variant) => {
              const serviceTypeId = variant?.ServiceType ? variant?._id : null;
              const serviceTypeName =
                variant?.ServiceType?.Name !== "NA"
                  ? variant?.ServiceType?.Name
                  : service?.ChildCatIDs?.CCName;
              return {
                value: serviceTypeId,
                label: `${service.ServiceName} (${serviceTypeName})`,
                type: "Service",
              };
            })
          ) || [];

      const selectedPackages = combineData?.Package?.filter((packag) =>
        selectedChildCategories?.some((category) =>
          packag.PcatId.includes(category)
        )
      ).map((packag) => ({
        value: packag._id,
        label: packag.packageTitle,
        type: "Package",
      }));
      const combinedOptions = [
        { label: "Services", options: selectedServices },
        { label: "Packages", options: selectedPackages },
      ];
      setServiceOptions(combinedOptions);
      setExServiceOptions(combinedOptions);
    } else {
      setServiceOptions([]);
    }
  }, [selectedChildCategories, combineData]);

  let services = serviceOptions[0]?.options ?? [];
  let packages = serviceOptions[1]?.options ?? [];

  let both = [...services, ...packages];

  useEffect(() => {
    if (selectAllInItem == true) {
      setSelectedOptions(both);
    } else {
      setSelectedOptions([]);
    }
  }, [selectAllInItem]);

  useEffect(() => {
    if (selectAllExItem == true) {
      setSelectedExOptions(both);
    } else {
      setSelectedExOptions([]);
    }
  }, [selectAllExItem]);

  useEffect(() => {
    if (selectAllDays == true) {
      setSelectedDays(daysOptions);
    } else {
      setSelectedDays([]);
    }
  }, [selectAllDays]);
  let a = [...selectedExOptions, ...selectedOptions];

  let finalInItemOptions = both.filter((item) => !a.includes(item));

  let normalUserOptions = [...selectedUsers, ...selectedexUsers];

  let normalUserOptionsIds = normalUserOptions.map((user) => user.value); // or user._id, adjust as per your data structure

  let finalInUserOptions = Users.filter((item) => {
    return !normalUserOptionsIds.includes(item._id);
  });

  const AddUsers = async (event) => {
    event.preventDefault();
    let body = {
      name: name,
      email: email,
      mobileNo: mobile,
    };
    try {
      let response = await privateRequest.post(`Appregister/AddNewUser`, body);
      if (response) {
        getUsers();
      }

      console.log("POST/PUT Response:", response);

      setShowModal(false);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "User added successfully!",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error?.response?.data?.message,
      });
      console.error("Add Error:", error);
    }
  };

  useEffect(() => {
    // Reset selectedFreeService when selectedParentCategory changes
    if (selectedParentCategory && combineData?.newServiceId) {
      const filteredServices = combineData.newServiceId.filter(
        (service) => service?.PCatId?.PCGroup === selectedParentCategory
      );
      if (filteredServices.length > 0) {
        // setSelectedFreeService(filteredServices[0]._id);
      } else {
        setSelectedFreeService('');
      }
    } else {
      setSelectedFreeService('');
    }
  }, [selectedParentCategory, combineData?.newServiceId]);

  return (
    <>
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">

                    {/* {
                      JSON.stringify(combineData?.newServiceId?.filter((service) => service.PCatId.PCGroup === selectedParentCategory).length)
                    } */}
                    {/* {
                      JSON.stringify(selectedParentCategory)
                    } */}
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Coupons</span>
                    </p>
                    <Link
                      to="/coupons"
                      className="btn btn-primary btn-sm ml-auto"
                    >
                      All Coupons
                    </Link>
                  </div>
                </header>
                <div className="page-section">
                  <form
                    id="new_coupon"
                    className="needs-validation"
                    noValidate=""
                    onSubmit={AddCoupons}
                  >
                    <div className="row">
                      <div className="col-lg-9">
                        <div className="card card-body">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="input-group  mb-3">
                                <input
                                  type="text"
                                  id="cpn_code"
                                  className="form-control"
                                  placeholder="Coupon Code"
                                  name="cpn_code"
                                  value={couponCode}
                                  required
                                  onChange={(e) =>
                                    setCouponCode(e.target.value)
                                  }
                                />
                                <div className="input-group-append">
                                  <button
                                    type="button"
                                    className="btn btn-primary rounded-0 generate_cpn"
                                    onClick={generateCoupon}
                                  >
                                    Generate Coupon
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-group">
                                <Select
                                  isClearable
                                  placeholder={"Select Parent Category Group"}
                                  label={selectedParentCategory}
                                  onChange={handleParentCategoryChange}
                                  options={
                                    combineData?.ParentGroup?.map(
                                      (category) => ({
                                        value: category._id,
                                        label: category.PCGName,
                                      })
                                    ) || []
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-group">
                                <Select
                                  placeholder={"Select Parent Category"}
                                  isMulti
                                  value={childCategoryOptions.filter((option) =>
                                    selectedChildCategories.includes(
                                      option.value
                                    )
                                  )}
                                  onChange={(selectedOptions) => {
                                    const selectedValues = selectedOptions.map(
                                      (option) => option.value
                                    );
                                    setSelectedChildCategories(selectedValues);
                                  }}
                                  options={childCategoryOptions}
                                />
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form-group">
                                <input
                                  type="text"
                                  id="cpn_title"
                                  className="form-control"
                                  placeholder="Coupon Title"
                                  name="cpn_title"
                                  value={couponTitle}
                                  onChange={(e) =>
                                    setCouponTitle(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-12">
                              <div className="form-group">
                                <input
                                  type="text"
                                  id="cpn_discription"
                                  className="form-control"
                                  placeholder="Coupon Discription"
                                  name="cpn_discription"
                                  value={couponSubTitle}
                                  onChange={(e) =>
                                    setCouponSubTitle(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                            <div className=" col-lg-12">
                              <div className="form-group">
                                <div className="d-flex justify-content-between align-items-center">
                                  <label htmlFor="coupon_days">
                                    Select Days
                                  </label>
                                  <div className="custom-control custom-control-inline custom-checkbox ml-5">
                                    <input
                                      type="checkbox"
                                      className="custom-control-input"
                                      id="days"
                                      onChange={(e) => {
                                        setselectAllDays(!selectAllDays);
                                      }}
                                    />
                                    <label
                                      className="custom-control-label"
                                      htmlFor="days"
                                    >
                                      Select All
                                    </label>
                                  </div>
                                </div>
                                <Select
                                  isMulti
                                  name="days"
                                  options={daysOptions}
                                  className="basic-multi-select"
                                  classNamePrefix="select"
                                  placeholder="Select Days"
                                  value={selectedDays}
                                  onChange={handleDaysChange}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card">
                          <div className="card-header nav-scroller">
                            {/* .nav-tabs */}
                            <ul className="nav nav-tabs card-header-tabs">
                              <li className="nav-item">
                                <a
                                  className="nav-link active show"
                                  data-toggle="tab"
                                  href="#general_C"
                                >
                                  General
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  className="nav-link"
                                  data-toggle="tab"
                                  href="#Uses_resti"
                                >
                                  Explore Usage restriction
                                </a>
                              </li>
                              <li className="nav-item">
                                <a
                                  className="nav-link"
                                  data-toggle="tab"
                                  href="#cpntnc"
                                >
                                  Coupon Terms &amp; Condition
                                </a>
                              </li>
                            </ul>
                            {/* /.nav-tabs */}
                          </div>
                          <div className="card-body">
                            <div className="row">
                              <div className="col-lg-12">
                                {/* Tab panes */}
                                <div className="tab-content">
                                  <div
                                    className="tab-pane active"
                                    id="general_C"
                                  >
                                    <div className="row">
                                      <div className="form-group col-lg-6">
                                        <label htmlFor="coupon_type">
                                          Coupon Type
                                        </label>
                                        <select
                                          className="form-control"
                                          value={couponType}
                                          onChange={(e) =>
                                            setCouponType(e.target.value)
                                          }
                                        >
                                          <option value="">Select Type</option>
                                          <option value="Fixed">Fixed</option>
                                          <option value="FreeService">
                                            Free Service
                                          </option>
                                          <option value="discount">
                                            Discount
                                          </option>
                                          <option value="FirstTime">
                                            First Time User
                                          </option>
                                        </select>
                                      </div>
                                      {couponType !== "FreeService" && (
                                        <div className="form-group col-lg-6">
                                          <label htmlFor="coupon_amount">
                                            Coupon Value
                                          </label>
                                          <input
                                            type="number"
                                            className="form-control"
                                            style={{}}
                                            name="coupon_amount"
                                            id="coupon_amount"
                                            value={couponValue}
                                            onChange={(e) =>
                                              setCouponValue(e.target.value)
                                            }
                                            defaultValue={0}
                                            placeholder={0}
                                          />
                                        </div>
                                      )}

                                      {couponType === "discount" && (
                                        <div className="form-group col-lg-6">
                                          <label htmlFor="coupon_capping">
                                            Coupon Capping
                                          </label>
                                          <input
                                            type="number"
                                            className="form-control"
                                            style={{}}
                                            name="coupon_capping"
                                            id="coupon_capping"
                                            defaultValue={0}
                                            placeholder={0}
                                            value={couponCapping}
                                            onChange={(e) =>
                                              setCouponCapping(e.target.value)
                                            }
                                          />
                                        </div>
                                      )}

                                      {/* {couponType === "FreeService" && (
                                        <select
                                          className="form-control m-4"
                                          value={selectedFreeService}
                                          onChange={(e) => {
                                            setSelectedFreeService(
                                              e.target.value
                                            );
                                          }}
                                        >
                                          {both?.map((option) => (
                                            <option
                                              key={option.value}
                                              value={option.value}
                                              disabled={option.disabled}
                                            >
                                              {option.label}
                                            </option>
                                          ))}
                                        </select>
                                      )} */}
                                      {/* <h1>

                                      {selectedParentCategory}
                                      <br></br>
                                      {combineData?.newServiceId?.filter((service) => service?.PCatId?.PCGroup === selectedParentCategory).map((item)=>{
                                        return(
                                          <h1>
                                            {item?.ServiceName}
                                          </h1>
                                        )
                                      })}
                                      </h1> */}


                                        {couponType === "FreeService" && (
                                          <div className="form-group col-lg-6">
                                            <label htmlFor="free_service">Select Service</label>

                                            <Select
                                              inputId="free_service" 
                                              className="m-0"
                                              placeholder="Search & Select Service"
                                              options={filteredOptions}
                                              value={freeServiceOptions.find(
                                                (opt) => opt.value === selectedFreeService
                                              )}
                                              onChange={(option) =>
                                                setSelectedFreeService(option ? option.value : null)
                                              }
                                              onInputChange={(inputValue) => setSearchInput(inputValue)}
                                              isClearable
                                              // isSearchable
                                              noOptionsMessage={() => "No service found"}
                                            />
                                          </div>
                                        )}
                                                                          
                                      <div className="form-group col-lg-6">
                                        <label htmlFor="minimum_amount">
                                          Minimum spend
                                        </label>
                                        <input
                                          type="number"
                                          className="form-control"
                                          style={{}}
                                          name="minimum_amount"
                                          id="minimum_amount"
                                          defaultValue=""
                                          placeholder="0"
                                          value={minSpend}
                                          onChange={(e) =>
                                            setMinSpend(e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className="form-group col-lg-6">
                                        <label htmlFor="expiry_date">
                                          Coupon Expiry Date
                                        </label>
                                        <input
                                          type="date"
                                          className="form-control"
                                          placeholder="YYYY-MM-DD"
                                          value={expiryDate}
                                          onChange={(e) =>
                                            setExpiryDate(e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className="form-group col-lg-6">
                                        <label htmlFor="usage_limit">
                                          Usage Limit Per Coupon
                                        </label>
                                        <input
                                          type="number"
                                          className="form-control"
                                          style={{}}
                                          name="usage_limit"
                                          id="usage_limit"
                                          defaultValue=""
                                          placeholder="Unlimited usage"
                                          step={1}
                                          min={0}
                                          value={couponUsesLimit}
                                          onChange={(e) =>
                                            setCouponUsesLimit(e.target.value)
                                          }
                                        />
                                      </div>
                                      <div className="form-group col-lg-6">
                                        <label htmlFor="usage_limit_per_user">
                                          Usage Limit Per User
                                        </label>
                                        <input
                                          type="number"
                                          className="form-control"
                                          style={{}}
                                          name="usage_limit_per_user"
                                          id="usage_limit_per_user"
                                          defaultValue=""
                                          placeholder="Unlimited usage"
                                          step={1}
                                          min={0}
                                          value={userUsesLimit}
                                          onChange={(e) =>
                                            setUserUsesLimit(e.target.value)
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="tab-pane" id="Uses_resti">
                                    <div className="row">
                                      <div className="col-12">
                                        <div id="cpn_ser_area">
                                          <hr />
                                          <div className="form-group">
                                            <div className="d-flex">
                                              <label>Include Items</label>
                                              <div className="custom-control custom-control-inline custom-checkbox ml-auto">
                                                <input
                                                  type="checkbox"
                                                  className="custom-control-input"
                                                  id="inc_package_checkbox"
                                                  onChange={(e) => {
                                                    setselectAllInItem(
                                                      !selectAllInItem
                                                    );
                                                  }}
                                                />
                                                <label
                                                  className="custom-control-label"
                                                  htmlFor="inc_package_checkbox"
                                                >
                                                  Select All
                                                </label>
                                              </div>
                                            </div>
                                            <Select
                                              isMulti
                                              value={selectedOptions}
                                              onChange={handleServiceChange}
                                              options={finalInItemOptions.filter(
                                                (option) =>
                                                  !selectedOptions.some(
                                                    (selected) =>
                                                      selected.value ===
                                                      option.value
                                                  )
                                              )}
                                              getOptionLabel={(option) =>
                                                option.label
                                              }
                                              getOptionValue={(option) =>
                                                option.value
                                              }
                                              getOptionIsDisabled={(option) =>
                                                option.disabled
                                              }
                                              formatGroupLabel={(data) => (
                                                <h6>{data.label}</h6>
                                              )}
                                            />

                                            <span
                                              className="select2 select2-container select2-container--default"
                                              dir="ltr"
                                              data-select2-id={2}
                                              style={{ width: "100%" }}
                                            >
                                              <span
                                                className="dropdown-wrapper"
                                                aria-hidden="true"
                                              />
                                            </span>
                                          </div>
                                        </div>
                                        <div id="cpn_pac_area">
                                          <hr />
                                          <div className="form-group">
                                            <div className="d-flex">
                                              <label>Exclude Item</label>
                                              <div className="custom-control custom-control-inline custom-checkbox ml-auto">
                                                <input
                                                  type="checkbox"
                                                  className="custom-control-input"
                                                  id="ex_package_checkbox"
                                                  onChange={(e) => {
                                                    setselectAllExItem(
                                                      !selectAllExItem
                                                    );
                                                  }}
                                                />
                                                <label
                                                  className="custom-control-label"
                                                  htmlFor="ex_package_checkbox"
                                                >
                                                  Select All
                                                </label>
                                              </div>
                                            </div>
                                            <Select
                                              isMulti
                                              value={selectedExOptions}
                                              onChange={handleServiceEXChange}
                                              options={finalInItemOptions.filter(
                                                (option) =>
                                                  !selectedExOptions.some(
                                                    (selected) =>
                                                      selected.value ===
                                                      option.value
                                                  )
                                              )}
                                            />
                                            <span
                                              className="select2 select2-container select2-container--default"
                                              dir="ltr"
                                              data-select2-id={2}
                                              style={{ width: "100%" }}
                                            >
                                              <span
                                                className="dropdown-wrapper"
                                                aria-hidden="true"
                                              />
                                            </span>
                                          </div>
                                        </div>
                                        <div id="cpn_pac_area">
                                          <hr />
                                          <div className="form-group">
                                            <div className="d-flex">
                                              <label>Include Users</label>
                                            </div>
                                            <Select
                                              isMulti
                                              options={finalInUserOptions.map(
                                                (user) => ({
                                                  value: user._id,
                                                  label: `${user.name} (${user.mobileNo})`,
                                                })
                                              )}
                                              onChange={handleUserChange}
                                            />

                                            <button
                                              type="button"
                                              id="newUser"
                                              className="btn btn-primary"
                                              onClick={handleShow}
                                            >
                                              Add New
                                            </button>

                                            <span
                                              className="select2 select2-container select2-container--default"
                                              dir="ltr"
                                              data-select2-id={2}
                                              style={{ width: "100%" }}
                                            >
                                              <span
                                                className="dropdown-wrapper"
                                                aria-hidden="true"
                                              />
                                            </span>
                                          </div>
                                        </div>
                                        <div id="cpn_pac_area">
                                          <hr />
                                          <div className="form-group">
                                            <div className="d-flex">
                                              <label>Exclude Users</label>
                                            </div>
                                            <Select
                                              isMulti
                                              options={finalInUserOptions.map(
                                                (user) => ({
                                                  value: user._id,
                                                  label: `${user.name} (${user.mobileNo})`,
                                                })
                                              )}
                                              onChange={handleexUserChange}
                                            />

                                            <span
                                              className="select2 select2-container select2-container--default"
                                              dir="ltr"
                                              data-select2-id={2}
                                              style={{ width: "100%" }}
                                            >
                                              <span
                                                className="dropdown-wrapper"
                                                aria-hidden="true"
                                              />
                                            </span>
                                          </div>
                                        </div>
                                        <div
                                          id="user_section"
                                          className="d-none"
                                        >
                                          <hr />
                                          <div className="form-group">
                                            <label>Allowed Users</label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="tab-pane" id="cpntnc">
                                    <div className="row mb-2">
                                      <div className="col-lg-12">
                                        <table className="table" id="tctable">
                                          <tbody>
                                            {couponDescription?.map(
                                              (description, index) => (
                                                <tr className="row" key={index}>
                                                  <td className="col-lg-11">
                                                    <input
                                                      type="text"
                                                      id={`cpn_discription_${index}`}
                                                      className="form-control"
                                                      placeholder="Coupon Description"
                                                      name="cpn_discription"
                                                      value={description}
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          index,
                                                          e
                                                        )
                                                      }
                                                    />
                                                  </td>
                                                  <td className="col-lg-1">
                                                    <button
                                                      type="button"
                                                      className="btn btn-primary btn-icon btnDelete"
                                                      onClick={() =>
                                                        handleDeleteInput(index)
                                                      }
                                                    >
                                                      x
                                                    </button>
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                      <div className="col-lg-12">
                                        <button
                                          type="button"
                                          className="btn btn-primary add_new_tc"
                                          onClick={handleAddInput}
                                        >
                                          Add T&amp;C
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  {/* <div className="tab-pane" id="cpntnc">
                            <div className="row mb-2">
                              <div className="col-lg-12">
                                <table className="table" id="tctable">
                                  <tbody>
                                    <tr className="row">
                                      <td className="col-lg-11">
                                        <input
                                          type="text"
                                          id="cpn_discription"
                                          className="form-control"
                                          placeholder="Coupon Discription"
                                          name="cpn_discription"
                                          value={couponDescription}
                                          onChange={(e) =>
                                            setcouponDescription(e.target.value)
                                          }
                                        />
                                      </td>
                                      <td className="col-lg-1">
                                        <button
                                          type="button"
                                          className="btn btn-primary btn-icon btnDelete"
                                        >
                                          x
                                        </button>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div className="col-lg-12">
                                <button
                                  type="button"
                                  className="btn btn-primary add_new_tc"
                                  onClick={duplicateInput}
                                >
                                  Add More T&amp;C
                                </button>
                              </div>
                            </div>
                          </div> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="card">
                          <div className="card-header">
                            <h4 className="card-title mb-0">Publish</h4>
                          </div>
                          <div className="card-body">
                            <div className="form-group">
                              <strong>Status</strong>
                              <select
                                className="form-control"
                                value={Status}
                                onChange={(e) => setStatus(e.target.value)}
                              >
                                <option value="">Select</option>
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                              </select>
                            </div>
                          </div>
                          <div className="card-footer bg-secondary p-2">
                            <button
                              type="submit"
                              className="btn btn-primary btn-sm ml-auto"
                              name="generate_coupon"
                            >
                              Generate Coupon
                            </button>
                          </div>
                          <input
                            type="hidden"
                            defaultValue="coupon_new"
                            id="action"
                            name="action"
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <div className="modal show d-block" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add New User</h5>
                <button type="button" className="close" onClick={handleClose}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form onSubmit={AddUsers}>
                  <div className="form-group">
                    <label htmlFor="mobileNo">Mobile No.</label>
                    <input
                      type="tel"
                      className="form-control"
                      id="mobileNo"
                      placeholder="Enter mobile number"
                      value={mobile}
                      required
                      onChange={(e) => {
                        setMobile(e.target.value);
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      placeholder="Enter name"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="Enter email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                    />
                  </div>
                  <button type="submit" className="btn btn-success">
                    Submit
                  </button>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleClose}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Addcoupons;
